// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kb-labfront.container .subscriber-link,
.kb-labfront.container .subscriber-link:hover {
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/components/pageElements/SubscriberLink/SubscriberLink.scss"],"names":[],"mappings":"AACE;;EAEE,kBAAA;AAAJ","sourcesContent":[".kb-labfront.container {\n  .subscriber-link,\n  .subscriber-link:hover {\n    position: relative;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
